import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "./router";
import "./styles.css";
import { initSentry, Sentry } from "@/lib/sentry";

// Inicializar Sentry antes del primer render
initSentry();

const router = getRouter();

// Fallback UI cuando un error no manejado sube hasta la raíz
function RootErrorFallback({ error }: { error: Error }) {
  return (
    <div
      style={{
        minHeight: "100svh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "24px",
        fontFamily: "system-ui, sans-serif",
        background: "#fafaf8",
        color: "#1a1a1a",
        textAlign: "center",
      }}
    >
      <p style={{ fontSize: "32px" }}>✦</p>
      <h1 style={{ fontSize: "18px", fontWeight: 700, margin: 0 }}>
        Algo salió mal
      </h1>
      <p style={{ fontSize: "13px", color: "#666", maxWidth: "320px", margin: 0 }}>
        Sift Trip encontró un error inesperado. Nuestro equipo fue notificado.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginTop: "8px",
          padding: "10px 24px",
          borderRadius: "12px",
          border: "1.5px solid #ddd",
          background: "#fff",
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: 600,
        }}
      >
        Recargar página
      </button>
      {import.meta.env.DEV && (
        <pre
          style={{
            marginTop: "16px",
            fontSize: "11px",
            color: "#999",
            textAlign: "left",
            maxWidth: "480px",
            overflow: "auto",
          }}
        >
          {error.message}
        </pre>
      )}
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }: { error: unknown }) => <RootErrorFallback error={error as Error} />}>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
